import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { dragNDropConstants } from '../../../Globals/constants';
import { DragSource } from 'react-dnd';
import Radium from 'radium';
import { } from '../../../Globals/styles';

class EmployeeDragable extends Component{
  componentWillMount = () => {
    this.props.connectDragPreview(null, {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true
    });
  };
  render()  {
    const { connectDragSource } = this.props;

    return connectDragSource(
      <div style={styles.dragable}>
        <img src="/images/Drag_and_Drop.png" alt="dragNDrop" />
      </div>
    );
  }
}

var styles = {
  dragable: {
    position: 'absolute',
    left: '0',
    height: '40px',
    width: '40px',
    textAlign: 'center',
    lineHeight: '40px',
    zIndex: '10',
    cursor: 'pointer'
  }

}

const EmployeeSource = {
  beginDrag(props) {
    props.setEmployeeIsDragging(props.employee.id)
    return {
      employeeIndex: props.index,
      employeeName: props.employee.name,
      employee: props.employee,
      isActive: false,
      getButtonContent: props.getButtonContent,
      isOpen: false
    };
  },
  endDrag(props){
    props.setEmployeeIsDragging(null)
  }
};
function collect(connect) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview()
    //isDragging: monitor.isDragging()
  }
}
  EmployeeDragable.propTypes = {
    employee: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      initials: PropTypes.string.isRequired
    }).isRequired,
    index: PropTypes.number.isRequired,
    getButtonContent: PropTypes.func.isRequired,
    setEmployeeIsDragging: PropTypes.func.isRequired
  };
export default DragSource(dragNDropConstants.EMPLOYEE, EmployeeSource, collect)(Radium(EmployeeDragable));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/EmployeeListView/employeeDragable.jsx